export default "__VITE_ASSET__292065c2__"